import Card from './Card';
import Features from './Features';

Features.Card = Card;

export { Card, Features };
export default Features;
